<template>
  <div id="app" class="wrap_content">
    <div class="header-wrapper">
      <header-component/>
    </div>
    <div class="menu-and-router">
      <div class="menu-emulation" id="menuEmulation" :style="{'min-width': menuEmulationWidth, 'max-width': menuEmulationWidth}">
        <item-dashboards/>
      </div>
      <router-view class="router-block"/>
    </div>
  </div>
</template>

<script>
import appStore from '@storages/appStore'
import adaptiveStore from '@storages/adaptiveStore'
import Header from '@/components/common/Header'
import ItemDashboards from '@/components/common/headerItems/ItemDashboards'

import 'leaflet/dist/leaflet.css'

export default {
  name: 'App',
  components: {
    'header-component': Header,
    'item-dashboards': ItemDashboards
  },

  computed: {
    menuEmulationWidth () {
      return adaptiveStore.getters.value('menuEmulationWidth')
    }
  },

  data () {
    return {
      lastWindowHeight: null,
      lastWindowWidth: null
    }
  },

  async created () {
    this.initAdaptiveStore()
    this.$eventHub.$on('hide-orders-list', this.hideOrdersList)
    this.$eventHub.$on('show-orders-list', this.showOrdersList)
    addEventListener('resize', this.resize)
    await this.getProfileDataMix().then(response => {
      appStore.dispatch('setValue', {key: 'profile', value: response.body})
    }).catch(err => {
      console.log('fail get profile data', err)
    })
    await this.getProductsMix().then(response => {
      appStore.dispatch('setValue', {key: 'products', value: response.body})
    }).catch(err => {
      console.log('fail get products', err)
      appStore.dispatch('setValue', {key: 'products', value: null})
    })
  },
  methods: {
    resize () {
      if (Math.abs(this.lastWindowHeight - window.innerHeight) > 100 || Math.abs(this.lastWindowWidth - document.body.clientWidth) > 100) {
        this.initAdaptiveStore()
        this.clearAllBodyScrollLocksMix()
      }
    },
    initAdaptiveStore () {
      this.lastWindowHeight = window.innerHeight
      this.lastWindowWidth = document.body.clientWidth
      adaptiveStore.dispatch('initStore')
    },
    showOrdersList () {
      adaptiveStore.dispatch('showOrdersList')
    },
    hideOrdersList () {
      adaptiveStore.dispatch('hideOrdersList')
    }
  }
}
</script>

<style lang="scss">
@import './assets/styles/reset.css';
// override leaflet style
.leaflet-map-pane canvas, .leaflet-pane, .leaflet-top, .leaflet-bottom { // иначе контролы превью вылезают над фулскрином
  z-index: 5!important;
}
.leaflet-control-attribution {
  display: none;
}
.leaflet-control-zoom {
  visibility: hidden;
}
.custom-legend-control {
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px 20px 5px;
  border-radius: 4px;
  margin-left: 10px;
}
.custom-legend-control__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin-bottom: 5px;
}
.custom-legend-control__row__marker {
  margin-left: 10px;
  width: 20px;
  height: 12px;
  border-radius: 3px;
  flex: none;
}
.custom-leaflet-tooltip { // при сборке стили не преопределяются. Попробуем с "!important"
  background: #303030!important;
  border: none!important;
  border-radius: 2px!important;
  color: white!important;
  font-size: 10pt!important;
}
.leaflet-tooltip-left.custom-leaflet-tooltip::before {
  border-left-color: transparent;
}
.leaflet-tooltip-right.custom-leaflet-tooltip::before {
  border-right-color: transparent;
}
#app {
  padding: 0px 0;
  overflow-y: hidden;
  height: 100vh;
}
.header-wrapper {
  height: 74px;
}
#popupWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 13px;
}
#popupArrow {
  width: 0;
  font-size: 11;
  border: 5px solid transparent;
  border-top: 5px solid black;
  display: none;
}
#chartPopup {
  // width: 220px;
  background-color: rgba(0, 0, 0, 0.57);
  color: white;
  padding: 12px 22px;
  // border: 1px solid black;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  position: relative;
}
#popupClose {
  display: none;
}
#popupClose:hover {
  cursor: pointer;
}
#popupTitle {
  padding: 0 7px;
  // font-weight: bold;
  font-size: 16px;
}
#popupButtonsBlock {
  display: flex;
  justify-content: center;
}
#popupButtonOnMap {
  // background-color: #2d325a;
  color: white;
  padding: 5px 7px;
  // margin-right: 5px;
  border-radius: 3px;
  font-weight: bold;
  font-size: 16px;
  text-decoration: underline;
}
#popupButtonOnMap:hover {
  cursor: pointer;
}
#popupButtonGoChild {
  color: white;
  padding: 5px 7px;
  font-weight: bold;
  font-size: 16px;
  text-decoration: underline;
}
body {
  font-family: 'PT Sans', sans-serif;
  background-color: #f8f8f8;
}
.fade-enter-active, .fade-leave-active {
  transition: .3s;
  left: 0;
  // opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  // transform: translateX(-110vw);
  // opacity: 0;
  left: -999px;
}
.shine {
  background: #f6f7f8;
  background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: inline-block;
  position: relative;
  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderShimmer;
  -webkit-animation-timing-function: linear;
}
@-webkit-keyframes placeholderShimmer {
  0% {
    background-position: -1768px 0;
  }

  100% {
    background-position: 1768px 0;
  }
}
.router-block {
  // width: calc(100% - 394px);
  width: 100%;
  // overflow-y: auto;
}
.menu-and-router {
  display: flex;
}
.menu-emulation {
  background-color: #f8f8f8;
  transition: .3;
}
* {
  scrollbar-color: red;
  scrollbar-width: thin;
}
::-webkit-scrollbar {
  width: 7px;
}
::-webkit-scrollbar:horizontal {
  // width: 5px;
  height: 7px;
}
::-webkit-scrollbar-track {
  border-radius: 5px;
  border: 1px solid rgba(128, 128, 128, 0.6);
}
::-webkit-scrollbar-thumb {
  background-color: rgba($color: #000000, $alpha: 0.3);
  border-radius: 5px;
  border: 1px solid rgba(128, 128, 128, 0.5);
}
// стили тултипа(всплывающей подсказки)
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: rgba(0, 0, 0, 0.85);
    color: white;
    border-radius: 10px;
    padding: 25px;
    font-size: 16px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: rgba(0, 0, 0, 0.85);
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 20px;

    .tooltip-arrow {
      border-width: 15px 15px 15px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -15px;
      top: calc(50% - 15px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

@media (min-width: 319px) and (max-width: 425px) {
  .menu-emulation {
    min-width: 0;
    max-width: 0;
  }
  #app {
    padding: 0px 0;
    overflow-y: auto;
    height: unset;
  }
  #popupClose {
    display: block;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .menu-emulation {
    min-width: 42px;
    max-width: 42px;
  }
  #popupClose {
    display: block;
  }
}
@media (min-width: 320px) and (max-width: 425px) {
  .header-wrapper {
    height: 77px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue